import React, { useCallback, useEffect, useRef, useState } from 'react'
import { SuccessModal, ErrorModal, PaymentModal } from '../../components/Modal'
import FreezedPhonesSelectEmployeeModal from '../../components/Modal/FreezedPhonesSelectEmployeeModal'
import { useLocation, useNavigate } from 'react-router-dom'
import NoDollar from '../CreateProducts/NoDollar'
import Layout from '../../components/Layout'
import Button from '../../components/Button'
import ViewItemStyle from './ViewItemStyle'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import api, { customFuncsApi } from '../../api'
import { roundCurrency } from '../../utils'
import moment from 'moment'
import customMainApi from '../../api'
import { Popconfirm, Tag, Button as AntButton } from 'antd'
import _ from 'lodash'
import ViewImage from '../../components/ViewImage/index'
import { getPhotos } from '../../utils/getPhotos'
import { BsEyeFill } from 'react-icons/bs'
import ClientInfoModal from '../../components/Modal/ClientInfo'
import { formatNumberWithIntl } from '../../utils/formatNumber'
import { Input, Select, Table } from 'antd'
import AddPoliceOutgoingModal from '../../components/Modal/AddPoliceOutgoingModal'
import { BG_COLOR } from '../../constants/colors'

const ViewItem = () => {
	const navigate = useNavigate()
	const location = useLocation()

	const successModalRef = useRef()
	const successRef = useRef()
	const errorRef = useRef()
	const noDollarRef = useRef()
	const paymentRef = useRef()
	const undiruvchiRef = useRef()
	const policeExpenseRef = useRef()
	const [isPoliceExpenseOpen, setIsPoliceExpenseOpen] = useState(false)

	const { getMe } = useSelector((state) => state.main)
	const isRoleUndiruvchi = [
		'Undiruvchi1',
		'Undiruvchi2',
		'Undiruvchi3',
		'Undiruv',
	].includes(get(getMe, 'Department2.Name', ''))

	const data = get(location, 'state', {})
	const from = get(location, 'state.from', '')

	const DocEntry = get(location, 'state.DocEntry', 0)
	const [u_Score, setU_Score] = useState('')
	const [tableInvoicePayments, setTableInvoicePayments] = useState([])

	const [isCommitLoading, setIsCommitLoading] = useState(false)

	const getNoDollarRef = useCallback((ref) => {
		noDollarRef.current = ref
	}, [])

	const [tableData, setTableData] = useState([])
	const [downloadData, setDownloadData] = useState({ state: location.state })
	const [sumPay, setSumPay] = useState(0)
	const [paymentSum, setPaymentSum] = useState(0)
	const [dollar, setDollar] = useState(1)
	const [invoice, setInvoice] = useState({})
	const [dollarLoading, setDollarLoading] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [isLoading2, setIsLoading2] = useState(false)
	const [userFields, setUserFields] = useState([])
	const [slp, setSlp] = useState('')
	const [salesPerson, setSalesPerson] = useState([])
	const [totalDebt, setTotalDebt] = useState(0)
	const [isFreezed, setIsFreezed] = useState('')
	const [loadingCancelBtn, setLoadingCancelBtn] = useState(false)
	const [firstIsFreezed, setFirstIsFreezed] = useState('') //Backdan kevotgani bilan mijoz ozgartirganmi yoqmi tekshirish uchun ochildi
	const [freezedPhoneEmployee, setFreezedPhoneEmployee] = useState('') //Backdan kevotgani bilan mijoz ozgartirganmi yoqmi tekshirish uchun ochildi
	const [path, setPath] = useState([])
	const [isClientInfoModalOpen, setIsClientInfoModalOpen] = useState(false)
	const [invoiceDocLines, setInvoiceDocLines] = useState([])
	const [itemsData, setItemsData] = useState([])
	const [invoiceLoading, setInvoiceLoading] = useState(false)
	const [isAddonWord, setIsAddonWord] = useState('')

	useEffect(() => {
		getInformationOfItem()
		getInfoOFDevice()
		userFieldsFn()
		getSalesPersons()
		getInvoicePayments()
		getUSD()
	}, [])

	const getInvoicePayments = () => {
		setIsLoading(true)
		customFuncsApi
			.get(`XsSql/getInvoiceIncomingPayments?docEntry=${DocEntry}`, {
				headers: {
					Prefer: 'odata.maxpagesize=100',
				},
			})
			.then((res) => {
				setTableInvoicePayments(res.data.value)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OINV'",
					$select: 'Name,ValidValuesMD,TableName',
				},
				headers: {
					Prefer: 'odata.maxpagesize=1000000',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const getSalesPersons = () => {
		api
			.get(`SalesPersons`, {
				headers: {
					Prefer: 'odata.maxpagesize=1000000',
				},
			})
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setSalesPerson(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(
						JSON.parse(err.response.data),
						'error.message',
						'Не удалось получить серийный номер. Повторите попытку.',
					),
				)
			})
	}

	const getInformationOfItem = () => {
		setIsLoading(true)
		customFuncsApi
			.get(`XsSql/getInstallments?docEntry=${DocEntry}`, {
				headers: {
					Prefer: 'odata.maxpagesize=50',
				},
			})
			.then((res) => {
				// const resData = res.data.value || []
				// setTableData2(resData)
				// setTableData(resData)
				// setIsLoading(false)
				// let a = JSON.parse(JSON.stringify(resData))
				// let allSum = 0
				// let paymentSum = 0
				// for (let i = 0; i < a.length; i++) {
				// 	allSum = allSum + a[i].PaidToDate
				// 	paymentSum = paymentSum + a[i].InsTotal
				// }
				// setSumPay(allSum)
				// setPaymentSum(paymentSum)
				const resData = res.data.value || []
				setTableData(resData)
				setIsLoading(false)
				let a = JSON.parse(JSON.stringify(resData))
				let allSum = 0
				let paySum = 0
				const now = moment().format('YYYYMMDD')
				for (let i = 0; i < a.length; i++) {
					if (!moment(a[i].DueDate, 'YYYYMMDD').isAfter(now, 'day')) {
						allSum = allSum + a[i].PaidToDate
						paySum = paySum + a[i].InsTotal
					}
				}
				setSumPay(allSum)
				setPaymentSum(paySum)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const getUSD = () => {
		setDollarLoading(true)
		api
			.post(`SBOBobService_GetCurrencyRate`, {
				Currency: 'UZS',
				Date: moment(),
			})
			.then((res) => {
				setDollar(JSON.parse(res.data))
			})
			.catch((err) => {
				setDollar('error')
			})
			.finally(() => setDollarLoading(false))
	}

	const getInfoOFDevice = () => {
		setIsLoading2(true)
		setInvoiceLoading(true)
		api
			.get(`Invoices(${DocEntry})`)
			.then((res) => {
				const docLines = get(JSON.parse(res.data), 'DocumentLines', [])
				const docTotal = get(JSON.parse(res.data), 'DocTotal', '')
				const paidToDate = get(JSON.parse(res.data), 'PaidToDate', '')
				const isFreezed = get(JSON.parse(res.data), 'U_IsFreezed', '')
				const U_Undrkim = get(JSON.parse(res.data), 'U_Undrkim', '')
				const photoId = get(JSON.parse(res.data), 'U_PhotoID', '')
				const isAddonWord = get(res.data, 'U_IsAddOnWord', '')

				getItems(docLines.map((v) => v.ItemCode))
				setIsLoading2(false)
				setInvoice(JSON.parse(res.data))
				setDownloadData(JSON.parse(res.data))
				setU_Score(get(JSON.parse(res.data), 'U_Score', ''))
				setTotalDebt(+docTotal - +paidToDate)
				const SalesPersonCode = get(JSON.parse(res.data), 'SalesPersonCode', '')
				setSlp(SalesPersonCode)
				setIsFreezed(isFreezed)
				setFirstIsFreezed(isFreezed)
				setFreezedPhoneEmployee(U_Undrkim)
				setInvoiceDocLines(docLines)
				setIsAddonWord(isAddonWord)

				getPhotos(photoId, setPath)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setInvoiceLoading(false)
			})
	}

	const getItems = (codes) => {
		console.log(codes)
		const filterQuery = `${codes.map((v, i) => `${i === 0 ? '' : ' or '}ItemCode eq '${v}'`).join('')}`
		api
			.get(
				`Items?$filter=${filterQuery}&$select=ItemCode,ItemName,U_Color,U_Condition,U_Group,U_Brand,U_Memory`,
			)
			.then((res) => {
				// setInfo1(
				// 	get(JSON.parse(res.data), 'U_Condition', 'Состояние не найден'),
				// )
				setItemsData(JSON.parse(res.data).value)
				// setInfo2(get(JSON.parse(res.data), 'U_Color', 'Цвет не найден'))
				// setItemGroup(get(JSON.parse(res.data), 'U_Group', 'Группа не найден'))
				// setBrand(get(JSON.parse(res.data), 'U_Brand', 'Бренд не найден'))
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const allSaves = () => {
		setIsCommitLoading(true)
		const photoId = path
			.map((image) => image.path)
			.filter(Boolean)
			.join(',')
		api
			.patch(`Invoices(${get(data, 'DocEntry', 0)})`, {
				U_Score: u_Score,
				U_IsFreezed: isFreezed,
				U_PhotoID: photoId,
			})
			.then(() => {
				successRef.current?.open('Заказ успешно сохранен')
				setIsCommitLoading(false)
			})
			.catch((err) => {
				setIsCommitLoading(false)
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}
	const allSavesWithEmployee = (employee) => {
		setIsCommitLoading(true)
		const photoId = path
			.map((image) => image.path)
			.filter(Boolean)
			.join(',')
		api
			.patch(`Invoices(${get(data, 'DocEntry', 0)})`, {
				U_Score: u_Score,
				U_IsFreezed: isFreezed,
				U_Undrkim: employee,
				U_PhotoID: photoId,
				U_DateOdConfis: moment().format('YYYY-MM-DD HH:mm:ss'),
			})
			.then(() => {
				successRef.current?.open('Заказ успешно сохранен')
				setIsCommitLoading(false)
			})
			.catch((err) => {
				setIsCommitLoading(false)
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const createPayment = ({
		DocDate,
		CurrencyRate,
		AmountUsd,
		AmountUzs,
		AmountPayme,
		NumberCard,
		Terminal,
		UsdCard,
	}) => {
		setIsLoading(true)
		const payments = []
		if (AmountUsd) {
			payments.push({
				usdSum: AmountUsd,
				account: UsdCard || getMe.U_CashAccount,
				currency: 'USD',
				uzsSum: null,
			})
		}
		if (AmountUzs) {
			payments.push({
				usdSum: AmountUzs / CurrencyRate,
				account: getMe.U_CashUzsAccount,
				currency: 'UZS',
				uzsSum: AmountUzs,
			})
		}
		if (AmountPayme) {
			payments.push({
				usdSum: AmountPayme / CurrencyRate,
				account: NumberCard || getMe.U_CardAccount,
				currency: 'UZS',
				uzsSum: AmountPayme,
			})
		}
		if (Terminal) {
			payments.push({
				usdSum: Terminal / CurrencyRate,
				account: getMe.U_TerminalAccount,
				currency: 'UZS',
				uzsSum: Terminal,
			})
		}
		customFuncsApi
			.post('addIncomingPayments', {
				DocDate,
				DocEntry: DocEntry,
				CardCode: get(data, 'CardCode', null),
				DocRate: CurrencyRate,
				payments: payments,
			})
			.then((err) => {
				// try {
				// 	logsUrl.post('apis', {
				// 		company_name: COMPANY_NAME,
				// 		method: 'post',
				// 		path: `/addIncomingPayments`,
				// 		description: "sotuvga to'lov",
				// 		username: `${getMe.FirstName} ${getMe.LastName}, EmployeeID: ${getMe.EmployeeID}`,
				// 		body: JSON.stringify({
				// 			DocDate,
				// 			DocEntry: DocEntry,
				// 			CardCode: get(data, 'CardCode', null),
				// 			DocRate: CurrencyRate,
				// 			payments: payments,
				// 		}),
				// 	})
				// } catch (err) {
				// 	errorRef.current?.open(
				// 		'Bu jarayon logs tarixiga saqlanmadi. Iltimos bu haqida bizga habar bering!',
				// 	)
				// }
				paymentRef.current?.close()
				successModalRef.current?.open('Платеж успешно произведен!')
				getInformationOfItem()
			})
			.catch((err) => {
				paymentRef.current?.close()
				errorRef.current?.open(JSON.stringify(err.response.data))
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	const cancel = () => {
		navigate(-1)
	}

	const handleClose = (docEntry) => {
		setLoadingCancelBtn(true)
		api
			.post(`Invoices(${docEntry})/Cancel`)
			.then((err) => {
				successModalRef.current?.open('Продажа успешно отменено!')
			})
			.catch((err) => {
				errorRef.current?.open(get(err.response, 'data', ''))
			})
			.finally(() => {
				setLoadingCancelBtn(false)
			})
	}

	const columns = [
		{
			title: 'Товар',
			dataIndex: 'ItemDescription',
			key: 'ItemDescription',
			width: 300,
		},
		{
			title: 'Cерийный номер',
			dataIndex: 'serialNumbersText',
			key: 'serialNumbersText',
			render: (val, record, index) => (
				<span>
					{record?.SerialNumbers?.map((v) => v.InternalSerialNumber).join(', ')}
				</span>
			),

			width: 200,
		},
		{
			title: 'Цвет',
			dataIndex: 'color',
			key: 'color',
			width: 150,
			render: (val, record, index) => (
				<span>
					{itemsData?.find((v) => v.ItemCode === record.ItemCode)?.U_Color ||
						'-'}
				</span>
			),
		},
		{
			title: 'Состояние',
			dataIndex: 'condition',
			key: 'condition',
			width: 150,
			render: (val, record, index) => (
				<span>
					{itemsData?.find((v) => v.ItemCode === record.ItemCode)
						?.U_Condition || '-'}
				</span>
			),
		},
		!isRoleUndiruvchi && {
			title: 'Текущая цена',
			dataIndex: 'GrossBuyPrice',
			key: 'GrossBuyPrice',
			render: (val, record, index) => <span>{formatNumberWithIntl(val)}</span>,
		},
		{
			title: 'Цена продажи',
			dataIndex: 'GrossTotal',
			key: 'GrossTotal',
			width: 150,
			render: (val, record, index) => <span>{formatNumberWithIntl(val)}</span>,
		},
		// {
		// 	title: 'Цена с учетом рассрочки',
		// 	dataIndex: 'priceWithPercent',
		// 	key: 'priceWithPercent',
		// 	render: (val, record, index) => {
		// 		const sum = calculateLinesPrice(record)
		// 		return <span>{formatNumberWithIntl(sum)}</span>
		// 	},
		// },
	].filter(Boolean)

	return (
		<Layout>
			<ViewItemStyle
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					<>
						<div>
							<div className="flex gap-5 flex-wrap">
								<div className="flex flex-col items-start gap-2">
									<p className={'font-bold text-sm'}>ФИО</p>
									<div className="flex items-center gap-2">
										<Input
											value={`${get(data, 'CardName', 'Покупатель')}`}
											className="w-[300px] h-9 disabled:text-gray-900"
											disabled={true}
										/>
										<Button
											onClick={() => setIsClientInfoModalOpen(true)}
											loading={isLoading}
											className="!h-9"
										>
											<BsEyeFill />
										</Button>
									</div>
								</div>
								<div className="flex flex-col items-start gap-2">
									<p className={'font-bold text-sm '}>Гарант</p>
									<Input
										value={`${get(data, 'U_Guarantor', '-') ?? '-'}`}
										className="w-[200px] h-9 disabled:text-gray-900"
										disabled={true}
									/>
								</div>
								<div className="flex flex-col items-start gap-2">
									<p className={'font-bold text-sm '}>
										Кому принадлежит телефон
									</p>
									<Input
										value={`${get(data, 'U_Owner', '-')}`}
										className="w-[200px] h-9 disabled:text-gray-900"
										disabled={true}
									/>
								</div>
								<div className="flex flex-col items-start gap-2">
									<p className={'font-bold text-sm '}>Менеджер продаж</p>
									<Input
										value={
											salesPerson.find(
												(v) => v.SalesEmployeeCode === Number(slp),
											)?.SalesEmployeeName
										}
										className="w-[200px] h-9 disabled:text-gray-900"
										disabled={true}
									/>
								</div>
								<div className="flex flex-col items-start gap-2">
									<p className={'font-bold text-sm '}>Аккаунт защиты</p>
									<Input
										value={`${get(invoice, 'U_Icloud', '-') ?? '-'}`}
										className="w-[200px] h-9 disabled:text-gray-900"
										disabled={true}
									/>
								</div>
							</div>
							<div className="mt-10 overflow-x-auto">
								<Table
									dataSource={invoiceDocLines}
									columns={columns}
									pagination={false}
									loading={invoiceLoading}
									scroll={{ x: 'max-content' }}
									bordered
									className=" border-[1px] border-gray-500 "
								/>
							</div>
							<div className=" mt-5">
								<div className="flex gap-5 items-center justify-between">
									<div className="flex gap-5 flex-wrap">
										<div className="flex flex-col items-start gap-2">
											<p className={'font-bold  text-sm'}>Статус</p>

											<Select
												value={u_Score}
												className="w-[200px] h-9 disabled:text-gray-900"
												onChange={(val) => {
													setU_Score(val)
												}}
												options={userFields
													?.find((item) => item.Name === 'Score')
													?.ValidValuesMD.map((value) => {
														return {
															value: value.Value,
															label: value.Description,
														}
													})}
												disabled={
													(isFreezed === 'Y' &&
														getMe?.Department2?.Name !== 'Boshqaruv') ||
													isRoleUndiruvchi
												}
											/>
										</div>
										<div className="flex flex-col items-start gap-2">
											<p className={'font-bold text-sm'}>
												У кого этот продукт?
											</p>
											<Select
												style={{
													color: '#111827',
												}}
												value={isFreezed}
												className="w-[200px] h-9 disabled:text-gray-900 [&_.ant-select-selector]:!text-gray-900"
												options={[
													{
														value: 'N',
														label: 'Mijozda',
													},
													{
														value: 'Y',
														label: 'Olib qo’yilgan',
													},
												]}
												onChange={(v) => {
													setIsFreezed(v)
												}}
												disabled={
													getMe?.Department2?.Name !== 'Boshqaruv' ||
													isRoleUndiruvchi
												}
											/>
										</div>
									</div>
									<div className="flex flex-col items-start gap-2">
										<p className={'font-bold text-sm '}>Комментария</p>
										<Input.TextArea
											className={
												'w-[300px] h-9 resize-none border-[1px] border-gray-500 disabled:text-gray-900'
											}
											disabled={true}
											value={`${get(data, 'Comments', '-')}`}
										/>
									</div>
								</div>

								{from !== 'black-list' && !isRoleUndiruvchi && (
									<div className="mt-10">
										<ViewImage
											path={path}
											setPath={setPath}
											docEntry={DocEntry}
											type={'Invoice'}
										/>
									</div>
								)}
							</div>
							{from !== 'black-list' && (
								<div className="flex gap-3 flex-col lg:flex-row justify-end w-full lg:col-span-2 sm:col-span-2 mb-10">
									{/* Bunda agar birinchi mijozda bolsa va user uni Olib qo'yilganga o'zgartirsa modalka save qilishdan oldin modal ochib undiruvchini tanlatishimiz kerak boladi */}
									{firstIsFreezed === 'N' && isFreezed === 'Y' ? (
										<Button
											btnStyle={{ width: 250 }}
											hoverBtnStyle={{ width: 250 }}
											onClick={() => {
												undiruvchiRef.current.open(freezedPhoneEmployee)
											}}
											isLoading={isCommitLoading}
											disabled={isRoleUndiruvchi}
											className="mt-2"
										>
											Сохранять
										</Button>
									) : (
										<Button
											btnStyle={{ width: 250 }}
											hoverBtnStyle={{ width: 250 }}
											onClick={allSaves}
											isLoading={isCommitLoading}
											disabled={isRoleUndiruvchi}
											className="mt-2"
										>
											Сохранять
										</Button>
									)}
								</div>
							)}
						</div>
						<div className="flex flex-col lg:flex-row gap-5 justify-end">
							{from !== 'black-list' && (
								<div className="w-full flex items-center">
									{getMe.Department2.Name === 'Boshqaruv' && (
										<Button
											btnStyle={{ backgroundColor: '#243AB5' }}
											onClick={() => {
												policeExpenseRef.current?.open({
													docEntry: DocEntry,
													installment: data.Installmnt,
													isAddonWord: isAddonWord,
												})
												setIsPoliceExpenseOpen(true)
											}}
										>
											Добавить милиция расходы
										</Button>
									)}
								</div>
							)}
							<div className="flex  items-center p-5 justify-center gap-5 rounded-3xl bg-white drop-shadow-xl ">
								<div className="flex gap-2 flex-col items-center">
									<Tag color="green" className=" text-sm">
										Курс
									</Tag>
									<span className="font-bold text-zinc-900">
										{dollar === 'error'
											? dollar
											: formatNumberWithIntl(dollar) + ' ' + 'UZS'}
									</span>
								</div>
								<div className="flex gap-2 flex-col items-center">
									<Tag color="red" className=" text-sm">
										Долг
									</Tag>
									<span className="font-bold text-zinc-900">
										{formatNumberWithIntl(paymentSum - sumPay)}
										USD
									</span>
								</div>
								<div className="flex gap-2 flex-col items-center">
									<Tag color="blue" className=" text-sm">
										Долг в UZS
									</Tag>
									<span className="font-bold text-zinc-900">
										{formatNumberWithIntl((paymentSum - sumPay) * dollar)}
										UZS
									</span>
								</div>
								<div className="flex gap-2 flex-col items-center">
									<Tag color="red" className="text-sm">
										Общий долг
									</Tag>
									<span className="font-bold text-zinc-900">
										{formatNumberWithIntl(Number(totalDebt))}
										USD
									</span>
								</div>
								{from !== 'black-list' && (
									<div>
										<Popconfirm
											title="Отменить продажу"
											description="Вы уверены, что хотите отменить продажу?"
											okText="Да"
											cancelText="Нет"
											onConfirm={() => {
												handleClose(DocEntry)
											}}
										>
											<AntButton
												loading={loadingCancelBtn}
												type="primary"
												danger
												className="!bg-red-600 h-10"
												disabled={isRoleUndiruvchi}
											>
												Отменить продажу
											</AntButton>
										</Popconfirm>
									</div>
								)}
								{from !== 'black-list' && (
									<div>
										{get(getMe, 'Department2.Name', '') !== 'Undiruvchi1' ||
										get(getMe, 'Department2.Name', '') !== 'Undiruvchi3' ? (
											<Button
												btnStyle={{ backgroundColor: '#243AB5' }}
												onClick={() => paymentRef.current?.open()}
												isLoading={isLoading || isLoading2 || dollarLoading}
												hoverBtnStyle={{ backgroundColor: '#243AB5' }}
												disabled={isFreezed === 'Y' || isRoleUndiruvchi}
											>
												Оплатить
											</Button>
										) : null}
									</div>
								)}
							</div>
						</div>
						<div>
							<div className="flex gap-10 justify-between items-start mb-8 mt-10">
								<div className="overflow-y-auto ">
									<h1 className="font-bold">План Платежа</h1>
									<table className="w-full text-sm text-left rtl:text-right text-black mt-5">
										<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
											<tr>
												<th scope="col" className="px-6 py-4">
													N
												</th>
												<th scope="col" className="px-6 py-4">
													Дата
												</th>
												<th scope="col" className="px-6 py-4">
													Оплата
												</th>
												<th scope="col" className="px-6 py-4">
													Оплачено
												</th>
											</tr>
										</thead>
										<tbody>
											{tableData.map((v, i) => {
												let a = v.DueDate.split('')
												a.splice(4, 0, '-')
												a.splice(7, 0, '-')
												a.join()
												return (
													<tr
														className="bg-white border-b  hover:bg-gray-50 "
														key={i}
													>
														<td className="px-6 py-4 font-medium text-gray-900 ">
															{i}
														</td>
														<td className="px-6 py-4 whitespace-nowrap">{a}</td>
														<td className="px-6 py-4">
															{Number(v.InsTotal).toFixed(2)}
														</td>
														<td className="px-6 py-4">
															{roundCurrency(v.PaidToDate)}
														</td>
													</tr>
												)
											})}
										</tbody>
									</table>
								</div>

								<div className="overflow-y-auto">
									<h1 className={'font-bold mb-3'}>Факт Платежа</h1>
									<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
										<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
											<tr>
												<th scope="col" className="px-6 py-4">
													N
												</th>
												<th scope="col" className="px-6 py-4">
													Дата
												</th>
												<th scope="col" className="px-6 py-4">
													Оплачено
												</th>
												<th scope="col" className="px-6 py-4">
													Курс
												</th>
												<th scope="col" className="px-6 py-4">
													Имя счета
												</th>
												{/* <th scope="col" className="px-6 py-4">
													Комментарий
												</th> */}
											</tr>
										</thead>

										<tbody>
											{tableInvoicePayments.length > 0 ? (
												tableInvoicePayments.map((v, i) => {
													const totalInUZS =
														Number(v.CashSum).toFixed(2) * Number(v.DocRate)
													return (
														<tr
															className="bg-white border-b  hover:bg-gray-50 "
															key={i}
														>
															<td className="px-8 py-6 font-medium text-gray-900 ">
																{' '}
																{Number(v.U_CashFlow) === 4 ||
																Number(v.U_CashFlow) === 5
																	? v['U_CashFlow.Descr']
																	: v?.visualInstNum}
															</td>

															<td className="px-6 py-4 whitespace-nowrap">
																{moment(v.DocDate).format('DD-MM-YYYY')}
															</td>
															<td className="px-6 py-4">
																{new Intl.NumberFormat('fr-FR', {
																	minimumFractionDigits: 2,
																	maximumFractionDigits: 2,
																})
																	.format(Number(v.CashSum))
																	.replace(',', '.')}{' '}
															</td>
															<td className="px-6 py-4">
																{new Intl.NumberFormat('fr-FR', {
																	minimumFractionDigits: 2,
																	maximumFractionDigits: 2,
																})
																	.format(Number(v.DocRate))
																	.replace(',', '.')}{' '}
															</td>

															<td className="px-6 py-4 ">{v.AcctName}</td>
															{/* <td className="px-8 py-6 font-medium text-gray-900 ">
																{' '}
																{Number(v.U_CashFlow) === 4 ||
																Number(v.U_CashFlow) === 5
																	? v.Comments
																	: '-'}
															</td> */}
														</tr>
													)
												})
											) : (
												<>
													<tr>
														<td colSpan={7} className="px-6 py-4">
															Ничего не найдено
														</td>
													</tr>
												</>
											)}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</>
					<div className="bottomCard justify-end mt-8">
						<Button btnStyle={{ backgroundColor: 'red' }} onClick={cancel}>
							Назад
						</Button>

						{from !== 'black-list' && (
							<Button
								btnStyle={{ marginLeft: 20, width: 200 }}
								onClick={() => {
									if (
										window.location.hostname.toLowerCase().includes('istyle')
									) {
										navigate('/ru_download', {
											state: { data: downloadData, user: data, tableData },
										})
									} else {
										navigate('/download', {
											state: { data: downloadData },
										})
									}
								}}
								disabled={isRoleUndiruvchi}
							>
								Загрузить договор(Ру)
							</Button>
						)}
						{window.location.hostname.toLowerCase().includes('istyle') && (
							<Button
								btnStyle={{ marginLeft: 20, width: 225 }}
								onClick={() =>
									navigate('/uz_download', {
										state: { data: downloadData, user: data, tableData },
									})
								}
							>
								Шартномани юклаш
							</Button>
						)}
					</div>
				</div>
			</ViewItemStyle>
			<>
				<FreezedPhonesSelectEmployeeModal
					getRef={(r) => (undiruvchiRef.current = r)}
					onConfirm={(employee) => allSavesWithEmployee(employee)}
					onClose={() => undiruvchiRef.current?.close()}
					loading={isCommitLoading}
				/>
				{dollarLoading ? null : (
					<PaymentModal
						getRef={(r) => (paymentRef.current = r)}
						onConfirm={(form) => createPayment(form)}
						onClose={() => paymentRef.current?.close()}
						loading={isLoading}
						currencyRate={dollar}
						debt={+totalDebt}
						isAddonWord={isAddonWord}
					/>
				)}
				{isPoliceExpenseOpen && (
					<AddPoliceOutgoingModal
						getRef={(r) => (policeExpenseRef.current = r)}
					/>
				)}

				<NoDollar getRef={getNoDollarRef} />
				<SuccessModal
					getRef={(r) => {
						successRef.current = r
					}}
					onConfirm={() => {
						navigate(-1)
					}}
				/>
				<SuccessModal
					getRef={(r) => (successModalRef.current = r)}
					onConfirm={() => {
						successModalRef.current?.close()
						navigate(-1)
					}}
				/>
				<ErrorModal getRef={(r) => (errorRef.current = r)} />
				{isClientInfoModalOpen && data.CardCode && (
					<ClientInfoModal
						isOpen={isClientInfoModalOpen}
						onClose={() => setIsClientInfoModalOpen(false)}
						clientCode={data.CardCode}
					/>
				)}
			</>
		</Layout>
	)
}

export default ViewItem
